'use strict';

var _ = require('underscore');
var SoaCollection = require('bunsen/collections/SoaCollection');
var endpoints = require('dibs-endpoints');
var PortfolioItem = require('bunsen/models/portfolio/PortfolioItemModel');

module.exports = SoaCollection.extend({

    model: PortfolioItem,

    url: function () {
        return endpoints.portfolioItemsByPortfolio(this.options.portfolioId);
    },

    initialize: function (models, options) {
        this.options = options || {};
        this.resetParams();
    },

    parse: function (data) {
        if (!data.result || !data.result.portfolio || !_.isArray(data.result.portfolio.items)) {
            return null;
        }
        if (_.isNumber(data.totalResults)) {
            this.totalResults = data.totalResults;
        }
        return data.result.portfolio.items;
    },

    sortById: function (idArray) {
        return this.reset(_.map(idArray, function (id) {
            return this.get(id);
        }, this));
    },

    saveSort: function () {
        var saveData = { items: [] };

        // create data structure
        this.each(function (portfolioItem) {
            var item = portfolioItem.get('item');
            saveData.items.push({
                id: portfolioItem.id,
                item: {
                    id: item.get('id'),
                    vertical: item.get('vertical'),
                    apiType: item.get('vertical') + 'Item'
                }
            });
        });

        // save to service
        return this.sync('update', this, {
            url: endpoints.portfolioSort(this.options.portfolioId),
            contentType: 'application/json',
            data: JSON.stringify(saveData)
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/portfolio/PortfolioItemCollection.js
// module id = 125
// module chunks = 63